import { useStore } from '../../UploadChannelPkg/store'
import { UPLOAD_TYPES } from 'constants.js'
import { SINGLE_UPLOAD_TIPS, SINGLE_UPLOAD_ULR_TIPS } from '../constants'
import MultiUploadTips from '../../../pureComponents/MultiUploadTips'
import MultiUploadUrlTips from '../../../pureComponents/MultiUploadUrlTips'
import { setPathName } from '../../../router'
import React, { useEffect, useCallback } from 'react'

const useUploadSetting = (props = {}) => {
    const [store = {}, dispatch] = useStore()
    const { formError, formData, uploadType } = store
    const { channelPkgInfo = {} } = props
    const { channelName } = channelPkgInfo

    const handleFormDataChange = useCallback(
        (field, value) => {
            dispatch({
                type: 'formDataChange',
                data: {
                    field,
                    value: field === 'url' ? (value || '').trim() : value,
                },
            })
        },
        [dispatch]
    )

    useEffect(() => {
        if (channelName) {
            handleFormDataChange('channelName', channelName)
        }
    }, [channelName, handleFormDataChange])

    const handleUploadTypeChange = val => {
        dispatch({
            type: 'uploadTypeChange',
            data: val,
        })
    }

    const isSingle = _dialogType => {
        return _dialogType === 'singleReplace'
    }

    const getMultiUploadTips = () => {
        const onCancel = () => {
            props.onCancel && props.onCancel()
            setPathName('/static/upload_management')
        }
        return [<MultiUploadTips onClick={onCancel} />]
    }

    const getMultiUploadUrlTips = () => {
        const onCancel = () => {
            props.onCancel && props.onCancel()
            setPathName('/static/upload_management/processing')
        }
        return [<MultiUploadUrlTips onClick={onCancel} />]
    }

    const genTips = (_dialogType, _uploadType) => {
        return isSingle(_dialogType)
            ? _uploadType === UPLOAD_TYPES.LOCAL_UPLOAD
                ? SINGLE_UPLOAD_TIPS
                : SINGLE_UPLOAD_ULR_TIPS
            : _uploadType === UPLOAD_TYPES.LOCAL_UPLOAD
            ? getMultiUploadTips()
            : getMultiUploadUrlTips()
    }

    return { formError, formData, handleFormDataChange, handleUploadTypeChange, genTips, uploadType, isSingle }
}

export default useUploadSetting
